export default (requests) => {
    return {
        getCmsPage: (page) => {
            return requests.get('/cms/pages/' + page + '/content');
        },
        getCmsMainMenu: (language, countryCode) => {
            return requests.get(`/cms/categories/name/main-menu-mobile?languageCode=${language}&countryCode=${countryCode}`)
        }
    }
};
